export { Login } from "./login";
export { SignUp } from "./sign_up";
export { Logout } from "./logout";
export { Callback } from "./callback";
export { NotFound } from "./not_found";

export { HomePage } from "./home";
export { Reports } from "./reports";
export { Core } from "./core";
export { Info } from "./info";

export { Performance } from "./performance";



// WEBPACK FOOTER //
// ./src/views/index.js